<template lang="html">

  <section class="destacados pad-sec">
    <div class="container">
      <h2 class="title title-36">{{$t('actualidad.noticias.titulo')}}</h2>
      <div class="flex wrap justify-around">
        <template v-if="!!noticias">
          <noticia-el v-for="(e, key) in noticiasProcessed" :data="e" :key="key"></noticia-el>
        </template>
        <template v-else>
          <noticia-fake v-for="(e, key) in 6" :key="key"></noticia-fake>
        </template>
      </div>
    </div>
    <router-link class="btn btn-dark btn-center -pink-full" v-if="!small" :to="$t('enlaces.blog')" target="_blank">{{$t('actualidad.noticias.ir_blog')}}</router-link>
  </section>

</template>

<script lang="js">


  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import Noticia_el from '@/components/parts/noticia-el';
  import Noticia_fake from '@/components/parts/noticia-fake';

  import { mapGetters } from 'vuex'


  export default  {
    name: 'noticias',
    props: ['small'],
    created() {
      this.getData();
    },
    data() {
      return {
        noticias : ''
      }
    },
    computed: {
      noticiasProcessed : function (){
        let count = (this.small) ? '3' : this.noticias.length;
        return this.noticias.slice(0,count);
      },
      ...mapGetters({
        lang : 'getLanguage'
      })
    },
    methods : {
      getData (){
        axios.get(`actualidad?lang=${this.lang}`)
        .then(response => {
          this.noticias = response.data.noticias;

          let title = this.$t(`enlaces.seo.blog_categoria.${this.$route.params.id}.title`);
          let description = this.$t(`enlaces.seo.blog_categoria.${this.$route.params.id}.description`);
          document.title = title;
          document.head.querySelector("[property='og:title']").content = title;
          document.head.querySelector("[name=description]").content = description;
          document.head.querySelector("[property='og:description']").content = description;
        })
        .catch(error => console.log(error));
      }
    },
    watch : {
      'lang'(){
        this.getData();
        this.$router.push({ name: "blog" })
      }
    },
    components: {
      'noticia-el' : Noticia_el,
      'noticia-fake' : Noticia_fake
    }
  }
</script>

<style scoped>
.noticias {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/actualidad-parts/noticias.vue